//@ts-nocheck
export const filterTeret = (teret, conditions) => (Array.isArray(teret) ? teret.filter(conditions) : [teret].filter(conditions));
export const conditionsForTereti = (teret) => teret?.Vrsta !== "РЕШЕЊЕ НИЈЕ КОНАЧНО" && teret?.Vrsta !== "НАПОМЕНА";
export const conditionsForZabelezbe = (teret) => teret?.Vrsta === "РЕШЕЊЕ НИЈЕ КОНАЧНО" || teret?.Vrsta === "НАПОМЕНА";
export const applyConditionsAndFilter = (data, conditions) => filterTeret(data?.Tereti?.Teret, conditions).filter(Boolean);
